var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0853 18.7913H6.91866C4.16866 18.7913 2.33533 17.4163 2.33533 14.208V7.79134C2.33533 4.58301 4.16866 3.20801 6.91866 3.20801H16.0853C18.8353 3.20801 20.6687 4.58301 20.6687 7.79134V14.208C20.6687 17.4163 18.8353 18.7913 16.0853 18.7913Z",
    stroke: "#4318FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.502 13.75C13.0207 13.75 14.252 12.5188 14.252 11C14.252 9.48122 13.0207 8.25 11.502 8.25C9.98317 8.25 8.75195 9.48122 8.75195 11C8.75195 12.5188 9.98317 13.75 11.502 13.75Z",
    stroke: "#4318FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54358 8.70801V13.2913",
    stroke: "#4318FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4603 8.70801V13.2913",
    stroke: "#4318FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMoney);
export default __webpack_public_path__ + "static/media/walletMoney.1cb4c65d3ea7b62065a3c16b076f9275.svg";
export { ForwardRef as ReactComponent };